import Config from "../search/Config";

const parseRange = document.createRange();
const parse = Range.prototype.createContextualFragment.bind(parseRange);

const banner = (_data, _device)=>{
  let data = _data,
    markup='',
    backgroundImg='';
  if(_device == 'mobile'){
    backgroundImg = data['bannerImg-m'];
  }else{
    backgroundImg = data['bannerImg-w'];
  }
  markup = `
      <div class="forum-banner" style="background-image: url('${backgroundImg}')">
      ${
          data.isActive ? `
              <div class="forum-banner-tag">진행중</div>
              `
            : `
            <div class="forum-banner-tag end">종료</div>
            `
        }  
        <div class="forum-banner-title">${data.subject}</div>
        <div class="forum-banner-date">${data.date}</div>
      </div>
      <div class="forum-all">
        <div class="forum-all-title">모든 토론보기</div>
        <div class="forum-all-txt">지난 토론을 한눈에!</div>
        <a href="/board/forum/listall" class="forum-all-btn">바로가기</a>
      </div>
    `;

  return parse(markup);
}

const list = (_data, _categoryList, _year)=> {
  let markup = '';

  for (let key in _data) {
    let data = _data[key];
    const categoryId = _categoryList[data.categoryName]

      markup += `
        <li class="forum-list" data-year="${data.year}">
          <div class="forum-list-board">
              ${
        data.isActive ? `
                        <div class="forum-list-tag">진행중</div>
                        `
          : `
                      <div class="forum-list-tag end">종료</div>
                      `
      }  
              <a href="/board/forum/list?categoryId=${categoryId}" class="forum-list-title">${data.subject}</a>
              <a href="/board/forum/list?categoryId=${categoryId}" class="forum-list-desc">${data.content}</a>
          </div>
          <div class="forum-list-meta">
            <div class="forum-list-date">${data.date}</div>
          </div>
        </li>
          
        `;

  }

  return parse(markup);
}

const select = (_data)=>{
    let  markup='', itemsM='', itemsW='';

    for (let key in _data) {
      const data = _data[key]
      itemsM+=`
        <option value="${data.year}">${data.txt}</option>
      `;
      // itemsW+=`
      //    <li class="ui-dropdown-custom_items" data-value="${data.date}">${data.txt}</li>
      // `;
    }
    markup += `
    <div id="boardCategory" class="ui-dropdown-wrap board-category">
      <!-- mobile -->
      <div class="ui-dropdown ui-dropdown-elements">
        <div class="select">
          <select class="forum_select">
           ${itemsM}
          </select>
          <svg class="fe-svg fe-svg-arrow_down_s"><use xlink:href="#arrow_down_s"></use></svg>
        </div>
      </div>

      <!-- pc 
      <div class="ui-dropdown ui-dropdown-community">
        <div class="select">
          <span></span>
          <svg class="fe-svg fe-svg-arrow_down_s"><use xlink:href="#arrow_down_s"></use></svg>
        </div>
        <ul class="option">
           ${itemsW}
        </ul>
      </div>
    </div>
        -->
    `;



  return parse(markup);
}
const moreBtn = ()=>{
    let  markup='';


    markup += `
      <div class="wrap-community-more forum-more-btn">
      <button class="nc-comment-more" aria-label="더보기"><span class="txt">더보기</span></button>
    </div>
    `;



  return parse(markup);
}

export default {
  banner,
  list,
  select,
  moreBtn
}
